var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.53,
    height: 59.189,
    viewBox: "0 0 47.53 59.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50.426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.344,6.693A30.907,30.907,0,0,0,128.4.4a.867.867,0,0,0-.844-.389,30.9,30.9,0,0,0-6.7,1.857c-4.753,1.91-8.1,4.738-9.687,8.177-2.642,5.737-5.4,17.3-6.15,25.766a.867.867,0,0,0,.5.864l9.339,4.3a.867.867,0,0,0,.982-.181c5.95-6.076,12.94-15.686,15.582-21.423C133.012,15.93,132.983,11.547,131.344,6.693Z",
    transform: "translate(-48.282)",
    fill: "#ebeef2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.043,6.693A30.908,30.908,0,0,0,188.1.4a.867.867,0,0,0-.844-.389c-.031,0-.238.033-.583.094a29.039,29.039,0,0,1,1.987,5.53c1.154,4.638.93,8.909-.647,12.352-2.631,5.742-9.275,15.506-14.811,21.766a.824.824,0,0,1-.555.289.668.668,0,0,1-.124,0l2.04.939a.867.867,0,0,0,.982-.181c5.95-6.076,12.94-15.686,15.582-21.423C192.71,15.93,192.682,11.547,191.043,6.693Z",
    transform: "translate(-107.981)",
    fill: "#d1d6de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.676.008a30.9,30.9,0,0,0-6.7,1.857,20.8,20.8,0,0,0-7.067,4.469l18.769,8.357a21.044,21.044,0,0,0-1.218-8A30.9,30.9,0,0,0,195.52.4.867.867,0,0,0,194.676.008Z",
    transform: "translate(-115.401 0)",
    fill: "#fc5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.936.1a29.039,29.039,0,0,1,1.987,5.53,21.839,21.839,0,0,1,.609,7.726l2.992,1.332c.291-4.6-1.762-10.577-4.161-14.294a.867.867,0,0,0-.844-.389l-.02,0C295.434.02,295.238.048,294.936.1Z",
    transform: "translate(-216.244 0)",
    fill: "#e1591f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.35,
    cy: 3.35,
    r: 3.35,
    transform: "translate(68.688 13.484)",
    fill: "#8088a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.175,269.795a2.688,2.688,0,0,0-4.963-.193.872.872,0,0,0-.044.116l-2.637,8.874h0a1.366,1.366,0,0,0,.744,1.642,1.386,1.386,0,0,0,.581.129,1.366,1.366,0,0,0,1.15-.631l5.029-7.772a.872.872,0,0,0,.06-.108A2.67,2.67,0,0,0,133.175,269.795Z",
    transform: "translate(-66.371 -237.051)",
    fill: "#1accb3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.823,115.3a5.309,5.309,0,0,0-6.7,3.4l-.748,2.29a5.309,5.309,0,1,0,10.092,3.3l.748-2.29A5.315,5.315,0,0,0,335.823,115.3Z",
    transform: "translate(-245.588 -101.735)",
    fill: "#f9c295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.759,94.064a.866.866,0,0,0-.819-.274l-3.362.676a.256.256,0,0,1-.13-.008l-3.285-1.074a4.426,4.426,0,0,0-5.575,2.828l-1.285,3.932a.867.867,0,0,0,.555,1.093l2.621.857a.867.867,0,0,0,1.093-.555l.046-.14a1.067,1.067,0,0,1,1.345-.682l1.589.52a5.057,5.057,0,0,0,6.371-3.232l1.012-3.1A.868.868,0,0,0,348.759,94.064Z",
    transform: "translate(-251.021 -82.396)",
    fill: "#444966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.168,215.952a4.559,4.559,0,0,0-6.369.951l-6.29,8.5a.867.867,0,0,0,.248,1.258l6.338,3.831a.867.867,0,0,0,1.145-.226l5.879-7.939a4.524,4.524,0,0,0,.894-2.706A4.575,4.575,0,0,0,250.168,215.952Z",
    transform: "translate(-165.305 -190.198)",
    fill: "#ffd422"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.026 25.223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.225,219.754a4.549,4.549,0,0,0-.638-.395,4.576,4.576,0,0,1,.895,2.71,4.524,4.524,0,0,1-.894,2.706l-5.879,7.939a.867.867,0,0,1-1.145.226l-5.16-3.119c0,.021,0,.042.009.063a.867.867,0,0,0,.4.574l6.338,3.831a.867.867,0,0,0,1.145-.226l5.879-7.939a4.524,4.524,0,0,0,.894-2.706A4.575,4.575,0,0,0,250.225,219.754Z",
    transform: "translate(-230.387 -219.224)",
    fill: "#fd9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.344,220.714a2.651,2.651,0,0,0-1.8-.96L179.655,218.2h-.012a2.669,2.669,0,0,0-.524,5.311l13.893,1.552h.012q.132.013.263.013a2.669,2.669,0,0,0,2.056-4.364Z",
    transform: "translate(-176.716 -218.189)",
    fill: "#fd9811"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.426 45.522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.909,481.614H51.293a.867.867,0,0,1,0-1.734h8.616a.867.867,0,0,1,0,1.734Z",
    transform: "translate(-50.426 -469.926)",
    fill: "#dce0e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,438.562H73.449a.867.867,0,0,1,0-1.734H79.5a.867.867,0,1,1,0,1.734Z",
    transform: "translate(-70.021 -431.851)",
    fill: "#dce0e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.223,395.509h-2.562a.867.867,0,1,1,0-1.734h2.562a.867.867,0,1,1,0,1.734Z",
    transform: "translate(-96.74 -393.775)",
    fill: "#dce0e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.952,218.724a.867.867,0,0,0-.588-.329l-1.71-.191h-.012a2.669,2.669,0,0,0-.523,5.311l1.566.175a.866.866,0,0,0,.955-.745l.487-3.571A.867.867,0,0,0,181.952,218.724Z",
    transform: "translate(-111.69 -192.967)",
    fill: "#f9c295"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.952,322.845a.867.867,0,0,0-.343-.576l-5.926-4.387a.867.867,0,0,0-1.28.288L145.13,334.8a.867.867,0,0,0,.306,1.162l3.975,2.425a.867.867,0,0,0,1.14-.213l11.231-14.68A.868.868,0,0,0,161.952,322.845Z",
    transform: "translate(-83.659 -280.984)",
    fill: "#1290a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,309.073l-12.409-7.5a.867.867,0,0,0-1.145.226l-1.392,1.88a.855.855,0,0,0-.074.119l-.269.482a4.192,4.192,0,0,0,1.461,5.618l7.99,4.934-2.386,8.547a.867.867,0,0,0,.591,1.065l4.469,1.309a.867.867,0,0,0,1.078-.6l3.5-12.449A3.2,3.2,0,0,0,235,309.073Z",
    transform: "translate(-149.243 -266.597)",
    fill: "#075965"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment-method.07d3ae7baa43272c6e80ae395ae1da3b.svg";
export { ForwardRef as ReactComponent };